module.exports = __webpack_public_path__ + "img/title3.648206c3.png";